<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <h2 color="#6A158E" class="page-heading" v-text="page_title"></h2>

      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <catchup-form></catchup-form>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import CatchupForm from "../../../components/StudentPanel/catchups/Form";
export default {
  name: "AddWork",
  components: { CatchupForm, BreadCrumbs },
  data() {
    return {
      page_title: "Add Catch up Session",
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: "CatchUp",
          disabled: false,
          to: {
            name: "StudentCatchUp"
          }
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name
          }
        }
      ]
    };
  }
};
</script>

<style scoped>
.page-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}
</style>